module.exports = __webpack_public_path__ + "img/3-5.e9ceff0f.svg";